import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useLanguage } from '../context/LanguageContext';
import { HelpCircle } from 'lucide-react';

const FAQSection = () => {
  const { t } = useLanguage();

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            {t.faq.title}
            <span style={{ color: '#1F4FD8' }}>{t.faq.titleHighlight}</span>
          </h2>
          <p className="text-xl text-slate-600">
            {t.faq.subtitle}
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8" style={{ boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)' }}>
          <Accordion type="single" collapsible className="space-y-4">
            {t.faq.items.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-slate-200 rounded-2xl px-6 data-[state=open]:border-blue-200 data-[state=open]:bg-blue-50/30 transition-all"
              >
                <AccordionTrigger className="text-left py-5 hover:no-underline">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#E5E7EB' }}>
                      <HelpCircle className="w-4 h-4" style={{ color: '#1F4FD8' }} />
                    </div>
                    <span className="text-lg font-semibold text-slate-900 pr-4">
                      {faq.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-5 pl-12">
                  <p className="text-slate-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional Help */}
        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-2">
            {t.faq.moreQuestions}
          </p>
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="font-semibold transition-colors"
            style={{ color: '#1F4FD8' }}
          >
            {t.faq.contactUs}
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
